import { ITranslate } from "@/interfaces/ITranslate";

export const projectHasVehiclesTranslate: ITranslate = {
  comment: "el comentario de planificación",
  documentationResourceStatus: "el estado de la documentación",
  documentationIssues: "las incidencias en la documentación",
};
